var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitFreemium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_0_9400_466_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "url(#paint0_linear_9400_466)",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_1_9400_466_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 18.5,
    fill: "url(#paint1_linear_9400_466)",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 22.0019V20.0019C32.9996 19.6511 32.9071 19.3067 32.7315 19.003C32.556 18.6994 32.3037 18.4472 32 18.2719L25 14.2719C24.696 14.0963 24.3511 14.0039 24 14.0039C23.6489 14.0039 23.304 14.0963 23 14.2719L16 18.2719C15.6963 18.4472 15.444 18.6994 15.2685 19.003C15.0929 19.3067 15.0004 19.6511 15 20.0019V28.0019C15.0004 28.3526 15.0929 28.697 15.2685 29.0007C15.444 29.3043 15.6963 29.5565 16 29.7319L23 33.7319C23.304 33.9074 23.6489 33.9998 24 33.9998C24.3511 33.9998 24.696 33.9074 25 33.7319L27 32.5919M19.5 16.2719L28.5 21.4219M15.29 19.0019L24 24.0019M24 24.0019L32.71 19.0019M24 24.0019V34.0019M32.27 29.2719L34 31.0019M33 27.5019C33 28.8826 31.8807 30.0019 30.5 30.0019C29.1193 30.0019 28 28.8826 28 27.5019C28 26.1211 29.1193 25.0019 30.5 25.0019C31.8807 25.0019 33 26.1211 33 27.5019Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9400_466_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9400_466_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 18.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9400_466",
    x1: 25.213,
    y1: 8.91922,
    x2: 23.8224,
    y2: 44.1105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9400_466",
    x1: 25.0384,
    y1: 12.7349,
    x2: 23.9883,
    y2: 39.3079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitFreemium);
export default __webpack_public_path__ + "res/media/benefit-freemium.4571e28cb00a6c09846fcac5245f1408.svg";
export { ForwardRef as ReactComponent };